import { is_empty } from "utils/validations";

export const getSelectedData = (data, selected_id) => {
  if (is_empty(data)) return;
  return data.find(
    (item) => item.draft || (!is_empty(selected_id) && item.id === selected_id)
  );
};

export const validateData = (value, customValue = true) => {
  let selected_data = { ...value };
  delete selected_data.id;
  delete selected_data.draft;
  let temp = {};
  for (let key in selected_data) {
    if (is_empty(selected_data[key])) {
      temp[key] = customValue;
    }
  }
  return temp;
};

export const date_format = "MMMM DD, YYYY";

export const MEDIA_MENTION_CROP = {
  height: 100,
  width: 100,
};

export const MEDIA_MENTION_COVER_CROP = {
  height: 142,
  width: 239,
};

export const refreshIframe = () => {
  // refresh iframe
  let iframe = document.querySelector("#pageFrame");
  // eslint-disable-next-line no-self-assign
  iframe.src = iframe.src;
};

export const findSelectedData = (data, selected_id) => {
  if (is_empty(data)) return;
  return { ...data.find((item) => item?.id === selected_id) };
};
